import React, { useState, useMemo } from "react";
import { Table, Input, Tag, Avatar, Button, Space, Dropdown } from "antd";
import { SearchOutlined, DownOutlined } from "@ant-design/icons";
import { translations } from "../../../utils/Translation/staticTranslation";

const MerTable = ({ grouthData }) => {
  const lang = localStorage.getItem("language") || "ar";
  const t = translations[lang]?.MerchantAnalytics || {};
  const [searchTerm, setSearchTerm] = useState("");
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 5,
  });

  // ✅ Extract top_5 merchants from API response
  const merchants =
    grouthData?.result?.top_5?.map((item, index) => ({
      key: index + 1,
      name: item.name || "N/A",
      email: item.email || "N/A",
      stores: item.stores?.toLocaleString() || "0",
      views: item.clicks?.toLocaleString() || "0",
      impressions: item.impressions?.toLocaleString() || "0",
      products: item.products?.toLocaleString() || "0",
      country: item.country || "Unknown",
      flag: item.country?.toLowerCase() || "sa",
      status: item.active
        ? t.tables?.active || "Active"
        : t.tables?.inactive || "Inactive",
      profile: item.profile,
    })) || [];

  const filteredData = useMemo(() => {
    return merchants.filter((m) =>
      m.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [merchants, searchTerm]);

  const columns = [
    {
      title: t.tables?.merchants || "Merchants",
      dataIndex: "name",
      key: "name",
      render: (text, record) => (
        <Space>
          <Avatar
            src={
              record.profile
                ? record.profile
                : `https://ui-avatars.com/api/?name=${encodeURIComponent(
                    record.name
                  )}&background=random`
            }
          />
          <div>
            <div style={{ fontWeight: 500 }}>{record.name}</div>
            <div style={{ color: "#8c8c8c", fontSize: "12px" }}>
              {record.email}
            </div>
          </div>
        </Space>
      ),
    },
    {
      title: t.tables?.stores || "Stores",
      dataIndex: "stores",
      key: "stores",
    },
    {
      title: t.tables?.clicks || "Clicks",
      dataIndex: "views",
      key: "views",
    },
    {
      title: t.tables?.impressions || "Impressions",
      dataIndex: "impressions",
      key: "impressions",
    },
    {
      title: t.tables?.products || "Products",
      dataIndex: "products",
      key: "products",
    },
    {
      title: t.tables?.country || "Country",
      dataIndex: "country",
      key: "country",
      render: (text, record) => (
        <Space>
          <img
            src={`https://flagcdn.com/w40/${record.flag}.png`}
            alt={record.country}
            style={{
              width: "22px",
              borderRadius: "50%",
              objectFit: "cover",
            }}
            onError={(e) => (e.target.style.display = "none")}
          />
          <span>{record.country}</span>
        </Space>
      ),
    },
    {
      title: t.tables?.status || "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => {
        let color = "#101828";
        let background = "#F9FAFB";
        let border = "#E5E7EB";

        if (status === (t.tables?.active || "Active")) {
          color = "#027A48";
          background = "#ECFDF3";
          border = "#A4F4CF";
        } else if (status === (t.tables?.pending || "Pending")) {
          color = "#B54708";
          background = "#FFFAEB";
          border = "#FCD9BD";
        } else if (status === (t.tables?.waiting || "Waiting")) {
          color = "#155EEF";
          background = "#EFF8FF";
          border = "#BEDBFF";
        }

        return (
          <Tag
            style={{
              color,
              backgroundColor: background,
              border: `1px solid ${border}`,
              borderRadius: "8px",
              padding: "2px 10px",
              fontSize: "13px",
              fontWeight: 500,
            }}
          >
            {status}
          </Tag>
        );
      },
    },
  ];

  return (
    <div style={{ background: "#f9fafb" }}>
      {/* Header Section */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 16,
        }}
      >
        <h2 style={{ fontSize: "20px", fontWeight: 600, color: "#000000" }}>
          {t.tables?.top_merchants || "Top Merchants"}
        </h2>
      </div>

      {/* Table Section */}
      <div
        style={{
          background: "white",
          borderRadius: "12px",
          overflow: "hidden",
          borderTop: "1px solid #E5E7EB", // ✅ Added top border
          boxShadow: "0 1px 4px #E5E7EB",
        }}
      >
        <Table
          columns={columns}
          dataSource={filteredData}
          pagination={false}
          style={{
            borderRadius: "12px",
          }}
        />
      </div>
    </div>
  );
};

export default MerTable;
